var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.883 0A6.117 6.117 0 0125 6.117v12.766A6.117 6.117 0 0118.883 25H6.117A6.117 6.117 0 010 18.883V6.117A6.117 6.117 0 016.117 0h12.766zm0 1.596H6.117a4.521 4.521 0 00-4.521 4.521v12.766a4.521 4.521 0 004.521 4.521h12.766a4.521 4.521 0 004.521-4.521V6.117a4.521 4.521 0 00-4.521-4.521zM12.5 5.833c.526 0 .952.427.952.953v4.761h4.762a.952.952 0 010 1.905h-4.762v4.762a.952.952 0 01-1.904 0v-4.762H6.785a.952.952 0 010-1.904h4.761V6.785c0-.526.427-.953.953-.953z",
    stroke: "currentColor",
    strokeWidth: 0.25,
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default SvgCommonIconPlusSquare;